import React from 'react';
import PropTypes from 'prop-types';
import './Dropdown.Style.css';

export const Dropdown = ({
  options,
  label,
  onSelect,
  disabled,
  showLabel,
  selectedOptionValue,
  required,
}) => {
  const differentLabelAndValue = options.some(
    (item) => typeof item === 'object' && item !== null,
  );

  const optionList = differentLabelAndValue
    ? options.length > 0 &&
      options.map((item) => {
        return (
          <option key={item} value={item.value}>
            {item.label}
          </option>
        );
      })
    : options.length > 0 &&
      options.map((item) => {
        return (
          <option key={item} value={item}>
            {item}
          </option>
        );
      });

  const handleChange = (event) => {
    onSelect(event.target.value);
  };
  return (
    <div className="dropdown">
      {showLabel && <label htmlFor={label}>{label}</label>}
      <div>
        <select id={label} onChange={handleChange} disabled={disabled}>
          {selectedOptionValue && (
            <option selected value={selectedOptionValue}>
              {selectedOptionValue}
            </option>
          )}
          {!selectedOptionValue && label && (
            <>
              <option selected hidden>
                Choose {label} {required && '*'}
              </option>
              {optionList}
            </>
          )}
          {!selectedOptionValue && !label && optionList}
        </select>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  label: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  disabled: PropTypes.string,
  selectedOptionValue: PropTypes.string,
  showLabel: PropTypes.bool,
  required: PropTypes.bool,
};

Dropdown.defaultProps = {
  onSelect: undefined,
  disabled: undefined,
  selectedOptionValue: undefined,
  showLabel: false,
  required: false,
};
